import React from "react";

import { defineMessages, useIntl } from "react-intl";
import { Link } from "react-router-dom";

import { authCommonStyles as commonStyles } from "@mapmycustomers/auth";
import { Button } from "@mapmycustomers/ui";

import Path from "@app/enum/Path";

import styles from "./SuccessScreenCommon.module.scss";

const messages = defineMessages({
  description: {
    id: "auth.forgotPassword.form.success.description",
    defaultMessage:
      "If this email is registered with us, you'll receive a password reset link shortly.",
    description: "Text shown after a password reset is requested",
  },
  loginLink: {
    id: "auth.forgotPassword.form.success.loginLink",
    defaultMessage: "Return to login",
    description: "Title of the Back to Login Link",
  },
  title: {
    id: "auth.forgotPassword.form.success.title",
    defaultMessage: "Check your email",
    description: "Title shown after a password reset is requested",
  },
});

const ForgotPasswordSuccessScreen = () => {
  const intl = useIntl();

  return (
    <div className={commonStyles.container}>
      <p className={commonStyles.title}>{intl.formatMessage(messages.title)}</p>
      <p className={commonStyles.description}>{intl.formatMessage(messages.description)}</p>
      <Link className={styles.returnLink} to={Path.LOGIN}>
        <Button className={styles.returnButton} type="primary">
          {intl.formatMessage(messages.loginLink)}
        </Button>
      </Link>
    </div>
  );
};

export default ForgotPasswordSuccessScreen;
